// extracted by mini-css-extract-plugin
export default {"stickyHeader":"_customTable_stickyHeader__W-09r"};